'use client';

import { useSuspenseQuery } from '@tanstack/react-query';
import { ReactNode } from 'react';

import { getGeoData } from '@/lib/data/getGeoData';
import { GeoFeature } from '@/types';

import { useTenant } from '../tenant';
import { GeoContextData } from './context';
import { useGeoState } from './useGeoState';

export type GeoDataProviderProps = {
    children: ReactNode;
    initialData?: GeoFeature;
};

export function GeoDataProvider({
    children,
    initialData,
}: GeoDataProviderProps) {
    const tenant = useTenant();
    const { id } = useGeoState();

    const { data } = useSuspenseQuery({
        queryKey: ['geo', id],
        queryFn: () =>
            getGeoData({
                tenant,
                geoId: id,
            }),
        initialData: () =>
            initialData?.properties?.id && initialData.properties.id === id
                ? initialData
                : undefined,
    });

    return (
        <GeoContextData.Provider value={data}>
            {children}
        </GeoContextData.Provider>
    );
}
